<template>
  <div class="flex items-center gap-4">
    <div
      class="flex items-center justify-center text-primary-700 rounded-full fill-current h-11 w-11"
      :class="{
        'bg-neutral-200': highContrast,
        'bg-neutral-100': !lowContrast,
        'bg-neutral-white border border-neutral-300 border-solid': lowContrast,
      }"
    >
      <component
        :is="icon"
        :class="{
          'h-5 w-5': !largeIcon,
          'h-7 w-7': largeIcon,
        }"
      />
    </div>

    <div
      :class="{
        'md:text-3xl text-2xl font-faktum font-semibold': title,
        'text-lg font-semibold': !title,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import * as Icons from '../icons';

const iconMap = {
  ...Object.entries(Icons).reduce(
    (acc, [key, value]) => {
      const name = key
        .replace(/^Line/, '')
        .split(/(?=[A-Z])/)
        .map(s => s.toLowerCase())
        .join('-');

      acc[name] = value;

      return acc;
    },
    {} as Record<string, any>,
  ),
};

const props = defineProps({
  highContrast: {
    default: false,
    type: Boolean,
  },
  largeIcon: {
    default: false,
    type: Boolean,
  },
  lowContrast: {
    default: false,
    type: Boolean,
  },
  name: {
    default: '',
    type: String as PropType<keyof typeof iconMap>,
  },
  title: {
    default: false,
    type: Boolean,
  },
});

const icon = computed(() => {
  return iconMap[props.name];
});
</script>
